import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const referralRewardMenuRegistry = {
    core_referralReward: {
        label: "Referral Reward",
        link: PAGE_URL.REFERRAL_REWARD_PAGE,
        key: PAGE_URL.REFERRAL_REWARD_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default referralRewardMenuRegistry;
